export const keyboardToFilterMap = {
    KeyboardCategories: 'CATEGORY',
    KeyboardMerchants: 'MERCHANT',
    KeyboardTags: 'TAG',
    KeyboardAmountUpper: 'AMOUNT_UPPER',
    KeyboardAmountLower: 'AMOUNT_LOWER',
    KeyboardDates: 'DATES',
    KeyboardReceipts: 'RECEIPT',
    KeyboardAccounts: 'ACCOUNT',
    KeyboardSettings: 'SETTINGS',
};
